/**
 * ⟦A-20 « l'arc de rédemption » · A-74⟧ **La lecture qui raconte la remontée.**
 *
 * A-20, dans les mots de Mathieu : *« si le joueur joue bien, qu'il a eu un bad buzz, qu'il
 * est très descendu et qu'au final il a quand même réussi à gagner — c'est ça, l'arc de
 * rédemption »*. Et la consigne : *« rien à coder au moteur, c'est du contenu et de l'écran »*
 * — le moteur laisse déjà toutes les traces qu'il faut, personne ne les relisait.
 *
 * Ce module ne RECALCULE aucune règle (contrat de PASSATION §3) : il relit des cicatrices que
 * le moteur a gravées — la vidéo d'excuses tentée (`jalons_done` / `jalons_rates`), les crises
 * de SM (`sm_crisis_history_h`), le meme du ukulélé (flag de contenu permanent). Une victoire
 * sans aucune trace n'a pas d'arc : on ne raconte pas une rédemption à qui n'est jamais tombé.
 *
 * ⟦C60 · A-177⟧ **Le grand ménage : l'arc ne relit plus que les crises.** Il avait deux autres
 * cicatrices, nées des vidéos jalons : la vidéo d'excuses (le bad buzz comme sanction) et le meme du
 * ukulélé (l'excuses ratée). Les jalons n'existent plus, `jalons_done` reste vide et le flag
 * `ukulele` ne se pose plus : ces deux traces ne pouvaient plus apparaître, et leur texte est
 * retiré de l'écran. Reste ce qui a toujours existé : les semaines d'arrêt forcé des crises de santé
 * mentale. Les signatures ne bougent pas (`Victoire.tsx` les importe).
 */

import type { GameState } from "@maxime/shared";

/** Les cicatrices de la chute, en français — vide ⇔ pas d'arc à raconter. */
export function tracesDeLaChute(state: GameState): string[] {
  const traces: string[] = [];

  const crises = state.counters.sm_crisis_history_h.length;
  if (crises > 0) {
    traces.push(
      crises === 1 ? "deux semaines d'arrêt forcé" : `${crises} crises et leurs semaines d'arrêt`,
    );
  }
  return traces;
}

/**
 * ⟦A-20⟧ La victoire porte-t-elle un arc de rédemption ? Gagné + au moins une cicatrice.
 * Sert aux DEUX écrans que l'avenant nomme : le mémorial et l'écran de fin.
 */
export function arcDeRedemption(state: GameState): boolean {
  return state.victory_locked && tracesDeLaChute(state).length > 0;
}
